import { render, staticRenderFns } from "./DisasterView.vue?vue&type=template&id=056b6f5c&scoped=true&"
import script from "./DisasterView.vue?vue&type=script&lang=js&"
export * from "./DisasterView.vue?vue&type=script&lang=js&"
import style0 from "./DisasterView.vue?vue&type=style&index=0&id=056b6f5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056b6f5c",
  null
  
)

export default component.exports